/* istanbul ignore file */
import { RecommendationPointsResponse, RecommendedPracticesResponse } from '../types'
import { generatePath } from '../utils'
import { getMpAgent } from './utils'

const agent = getMpAgent()

const PATHS = {
  SUMMARY: '/program-engagement-recommendations/:engagementId',
  GOALS: '/program-engagement-recommendations/goals/:engagementId',
}

export class ProgramEngagementRecommendationsAPI {
  /** @deprecated - Still here for mp-node PDF generation */
  static summary(id: string, options?: any) {
    return agent
      .get<RecommendationPointsResponse>(generatePath(PATHS.SUMMARY, { engagementId: id }), options)
      .then(a => a.data)
  }

  static goals(id: string) {
    return agent
      .get<RecommendedPracticesResponse>(generatePath(PATHS.GOALS, { engagementId: id }))
      .then(a => a.data)
  }
}
